import { yupResolver } from "@hookform/resolvers/yup";
import { type FC, useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import * as yup from "yup";

import {
  type CreateEmailTemplateInput,
  EmailTemplateCategory,
  useCreateEmailTemplateRestApi,
} from "../../../hooks/useEmailTemplatesRestApi";
import { SendBulkEmailsPage } from "./SendBulkEmailsPage";

export interface FormData {
  name: string;
  subject: string;
  body: string;
  from: string;
  category: EmailTemplateCategory;
}

// バリデーションスキーマを定義
const validationSchema = yup.object({
  name: yup.string().required("テンプレート名は必須です"),
  subject: yup.string().required("件名は必須です"),
  from: yup.string().required("差出人は必須です"),
  category: yup
    .string()
    .oneOf(
      [
        EmailTemplateCategory.Hr,
        EmailTemplateCategory.Matter,
        EmailTemplateCategory.All,
      ],
      "有効なメール種別を選択してください",
    ),
  body: yup.string().required("本文は必須です"),
});

export const SendBulkEmailsPageContainer: FC = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const templateFormMethods = useForm<FormData>({
    resolver: yupResolver(validationSchema), // スキーマを追加
    defaultValues: {
      name: "",
      subject: "",
      body: "",
      from: "",
      category: EmailTemplateCategory.Hr,
    },
  });
  const { reset } = templateFormMethods;

  const { createEmailTemplate } = useCreateEmailTemplateRestApi();

  const clearMessages = useCallback(() => {
    setErrorMessage("");
  }, []);

  const onSubmit = useCallback(
    async (data: FormData): Promise<boolean> => {
      setErrorMessage("");
      setIsSubmitting(true);

      try {
        const input: CreateEmailTemplateInput = {
          name: data.name,
          subject: data.subject,
          body: data.body,
          from: data.from,
          category: data.category,
        };

        const res = await createEmailTemplate(input);

        if (res.success) {
          toast.success("テンプレートを保存しました", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
          });
          reset();
          return true;
        }

        setErrorMessage("テンプレートの保存に失敗しました");
        return false;
      } catch (_error) {
        setErrorMessage("テンプレートの保存に失敗しました");
        return false;
      } finally {
        setIsSubmitting(false);
      }
    },
    [createEmailTemplate, reset],
  );

  return (
    <SendBulkEmailsPage
      templateFormMethods={templateFormMethods}
      isSubmitting={isSubmitting}
      errorMessage={errorMessage}
      onSubmit={onSubmit}
      clearMessages={clearMessages}
    />
  );
};

export default SendBulkEmailsPageContainer;
